module.exports = __webpack_public_path__ + "img/event_black.3628ec82.svg";